import { render, staticRenderFns } from "./ReferenceToggleModal.vue?vue&type=template&id=3beeefd3&"
import script from "./ReferenceToggleModal.vue?vue&type=script&lang=ts&"
export * from "./ReferenceToggleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports